import "./ContentHeadStyles.scss";
import $ from "jquery";
const contentHead = () => {
    // TODO Improve
    const urlSearchParameters = new URLSearchParams(window.location.search);
    const errorMessageQueryParameter = urlSearchParameters.get("errorMessage");
    if (errorMessageQueryParameter === "industryNotFound") {
        $(".content_head .contentHeadWrapper .error-message")
            .text("We're sorry, we can't find that page right now. Search for a single company above or find a list of companies in a specific industry using our industry directory below.")
            .show();
        $(".grid .html .top_companies").hide();
        $(".business_directory_top_companies").hide();
    }
};
export { contentHead };
